export const SET_BASE_CURRENCIES = "currencies/SET_BASE_CURRENCIES";
